module.exports = __webpack_public_path__ + "c703b057ab2a6bdb90a7aa1d31d5a598.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/tourWorks/room8/audio4/516138_original.jpg
// module id = 907
// module chunks = 0